import { NgModule } from "@angular/core";
import { UiIconModule } from "../icon/icon.module";
import { UiExternalLinkComponent } from "./external-link.component";

// to do: remove the line below with the first import of UiLinkModule
// ts-unused-exports:disable-next-line
@NgModule({
  imports: [UiIconModule],
  declarations: [UiExternalLinkComponent],
  exports: [UiExternalLinkComponent],
})
export class UiLinkModule {}
